import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isEmpty } from 'lodash';

export function proposalRequestInstructionFilesValidator(
  FormGroup: AbstractControl
): ValidationErrors | null {
  const ProposalRequestFiles = FormGroup.get('ProposalRequestFiles')?.value;
  const ProposalRequestInstructions = FormGroup.get('instructions')?.value;

  let { errors } = FormGroup;

  if (
    !ProposalRequestInstructions &&
    (!Array.isArray(ProposalRequestFiles) || ProposalRequestFiles.length === 0)
  ) {
    errors = Object.assign(errors || {}, { instructionFiles: true });
  } else {
    if (errors) {
      delete errors['instructionFiles'];
    }
  }

  if (isEmpty(errors)) {
    errors = null;
  }

  FormGroup.setErrors(errors);
  return errors;
}
